import { Dates } from "@/services/cloudchipr.api";

const forecastSupportedDateRanges = ["month_to_date", "quarter_to_date"];

export const isForecastSupportedDateRange = (dates?: Dates) => {
  const dateRange = dates?.label;

  if (!dateRange) {
    return false;
  }

  return forecastSupportedDateRanges.includes(dateRange);
};
